import { render, staticRenderFns } from "./LicenseHelpLinks.vue?vue&type=template&id=8b0683c6&lang=pug"
import script from "./LicenseHelpLinks.vue?vue&type=script&lang=js"
export * from "./LicenseHelpLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports